<template>
  <el-dialog
    title="请选择要创建的模板"
    :visible.sync="dialogVisible"
    width="560px"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div style="padding: 10px 50px">
      <el-radio v-model="templateType" label="1" border>告知卡</el-radio>
      <el-radio v-model="templateType" label="2" border>告知栏</el-radio>
      <el-radio v-model="templateType" label="3" border>重大风险公告栏</el-radio>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="add">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "RiskNoticeTemplateAdd",
  components: {},
  props: {
    addResize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      templateType: "1"
    };
  },
  created() {},
  mounted() {},
  watch: {
    addResize: function(newVal, oldVal) {
      if (newVal) {
        this.dialogVisible = true;
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    // 获取告知模板列表
    async add() {
      let req = {
        schoolId: this.$store.state.schoolId,
        templateType: this.templateType
      };
      let res = await this.$Http.creatNoticeTemplate(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "添加成功!"
        });
        this.handleClose();
        this.$emit("getList");
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
